import { PriceBookAccountingCodeModel, PriceModel } from "./price-book.model";

export class LaborItemModel{
    ID: string
    ItemNumber: string
    IsFrequentlyUsed: boolean
    Description: string
    Category: {}
    AccountingCode: PriceBookAccountingCodeModel
    Note: string
    Cost: string = "0"
    IsPriceEditAllowed:boolean
    IsDescriptionEditAllowed: boolean
    IsDiscountExcluded:boolean
    IsTaxable:boolean
    StandardCost:string
    Prices:PriceModel[]
    IsActive:boolean
    ModifyDate:string
    IsAgreementExcluded:boolean
    public constructor(){
        this.ID=""
        this.Prices = []
        this.Note = ""  
        this.Category = {}
        this.ModifyDate = ""
    } 
}